// Generated by content tools/generate_map_tiles.py; row order from pkg/worldmap/map_terrain.json.
export const TERRAIN_SHEET = {
  "tileSize": 48,
  "variants": 6,
  "rows": {
    "grassland": 0,
    "forest": 1,
    "farmland": 2,
    "city": 3,
    "castle": 4,
    "dungeon": 5,
    "swamp": 6,
    "mountain": 7,
    "snow": 8,
    "desert": 9,
    "water": 10,
    "shore": 11,
    "ruins": 12,
    "interior": 13,
    "fog": 14,
    "sea": 15
  },
  "decorations": {
    "roof": 16,
    "keep": 17,
    "cave": 18,
    "forge": 19,
    "shrine": 20,
    "tavern": 21,
    "shop": 22,
    "farm": 23,
    "tower": 24,
    "ruins": 25,
    "graveyard": 26,
    "dock": 27,
    "mine": 28,
    "magic": 29,
    "ridge": 30,
    "canopy": 31,
    "town": 32,
    "village": 33,
    "gatehouse": 34,
    "stairs": 35,
    "torch": 36,
    "reeds": 37,
    "stump": 38,
    "flowers": 39,
    "bridge": 40,
    "pine": 41,
    "oak": 42,
    "deadTree": 43,
    "hill": 44,
    "mesa": 45,
    "outcrop": 46,
    "cliff": 47,
    "well": 48,
    "cart": 49,
    "fence": 50,
    "windmill": 51,
    "lantern": 52,
    "barrel": 53,
    "bones": 54,
    "offshore": 55
  },
  "blends": {
    "grassland": {
      "-1:0": 60,
      "1:0": 61,
      "0:-1": 62,
      "0:1": 63,
      "-1:-1": 64,
      "1:-1": 65,
      "-1:1": 66,
      "1:1": 67
    },
    "forest": {
      "-1:0": 68,
      "1:0": 69,
      "0:-1": 70,
      "0:1": 71,
      "-1:-1": 72,
      "1:-1": 73,
      "-1:1": 74,
      "1:1": 75
    },
    "farmland": {
      "-1:0": 76,
      "1:0": 77,
      "0:-1": 78,
      "0:1": 79,
      "-1:-1": 80,
      "1:-1": 81,
      "-1:1": 82,
      "1:1": 83
    },
    "city": {
      "-1:0": 84,
      "1:0": 85,
      "0:-1": 86,
      "0:1": 87,
      "-1:-1": 88,
      "1:-1": 89,
      "-1:1": 90,
      "1:1": 91
    },
    "castle": {
      "-1:0": 92,
      "1:0": 93,
      "0:-1": 94,
      "0:1": 95,
      "-1:-1": 96,
      "1:-1": 97,
      "-1:1": 98,
      "1:1": 99
    },
    "dungeon": {
      "-1:0": 100,
      "1:0": 101,
      "0:-1": 102,
      "0:1": 103,
      "-1:-1": 104,
      "1:-1": 105,
      "-1:1": 106,
      "1:1": 107
    },
    "swamp": {
      "-1:0": 108,
      "1:0": 109,
      "0:-1": 110,
      "0:1": 111,
      "-1:-1": 112,
      "1:-1": 113,
      "-1:1": 114,
      "1:1": 115
    },
    "mountain": {
      "-1:0": 116,
      "1:0": 117,
      "0:-1": 118,
      "0:1": 119,
      "-1:-1": 120,
      "1:-1": 121,
      "-1:1": 122,
      "1:1": 123
    },
    "snow": {
      "-1:0": 124,
      "1:0": 125,
      "0:-1": 126,
      "0:1": 127,
      "-1:-1": 128,
      "1:-1": 129,
      "-1:1": 130,
      "1:1": 131
    },
    "desert": {
      "-1:0": 132,
      "1:0": 133,
      "0:-1": 134,
      "0:1": 135,
      "-1:-1": 136,
      "1:-1": 137,
      "-1:1": 138,
      "1:1": 139
    },
    "water": {
      "-1:0": 140,
      "1:0": 141,
      "0:-1": 142,
      "0:1": 143,
      "-1:-1": 144,
      "1:-1": 145,
      "-1:1": 146,
      "1:1": 147
    },
    "shore": {
      "-1:0": 148,
      "1:0": 149,
      "0:-1": 150,
      "0:1": 151,
      "-1:-1": 152,
      "1:-1": 153,
      "-1:1": 154,
      "1:1": 155
    },
    "ruins": {
      "-1:0": 156,
      "1:0": 157,
      "0:-1": 158,
      "0:1": 159,
      "-1:-1": 160,
      "1:-1": 161,
      "-1:1": 162,
      "1:1": 163
    },
    "interior": {
      "-1:0": 164,
      "1:0": 165,
      "0:-1": 166,
      "0:1": 167,
      "-1:-1": 168,
      "1:-1": 169,
      "-1:1": 170,
      "1:1": 171
    },
    "fog": {
      "-1:0": 172,
      "1:0": 173,
      "0:-1": 174,
      "0:1": 175,
      "-1:-1": 176,
      "1:-1": 177,
      "-1:1": 178,
      "1:1": 179
    },
    "sea": {
      "-1:0": 180,
      "1:0": 181,
      "0:-1": 182,
      "0:1": 183,
      "-1:-1": 184,
      "1:-1": 185,
      "-1:1": 186,
      "1:1": 187
    }
  },
  "underground": {
    "cave": 56,
    "crypt": 57,
    "cellar": 58,
    "sewer": 59
  },
  "colors": {
    "grassland": "#507d3a",
    "forest": "#3a5d31",
    "farmland": "#745f39",
    "city": "#8b8267",
    "castle": "#717a79",
    "dungeon": "#4b5055",
    "swamp": "#4c6041",
    "mountain": "#606957",
    "snow": "#a1b6b3",
    "desert": "#a48653",
    "water": "#2d6579",
    "shore": "#b09a69",
    "ruins": "#5a6946",
    "interior": "#7d5f40",
    "fog": "#605843",
    "sea": "#14323e"
  },
  "default": "grassland",
  "version": "5caee700810a"
};
